import {BasePqForm} from "biz-ts/src/api/Paging";

export class DpqForm extends BasePqForm {
    id?: number = undefined
    sequence?: number = undefined
    name?: string = undefined
    alias?: string = undefined
    mac?: string = undefined
    username?: string = undefined
    active?: boolean = undefined
    online?: boolean = undefined
    bindAddress?: string = undefined
    isTest?: boolean = undefined
    productIds: Array<number> = []
    companyIds: Array<number> = []
}

export class DregisterForm {
    productId!: number
    name!: string
    mac!: string
    activeCode!: string

    constructor() {
        this.init()
    }

    init(): void {
        this.productId = -1
        this.name = ""
        this.mac = ""
        this.activeCode = ""
    }
}

export class DeditForm {
    id!: number
    name!: string
    alias!: string

    constructor(id: number, name: string, alias: string) {
        this.id = id
        this.name = name
        this.alias = alias
    }
}

export class DimportForm {
    productId!: number
    macs!: Array<string>

    constructor() {
        this.init()
    }

    init(): void {
        this.productId = -1
        this.macs = []
    }
}

export class DbatchGenerateForm {
    productId!: number
    number!: number

    constructor() {
        this.init()
    }

    init(): void {
        this.productId = -1
        this.number = 10
    }
}

export class DsharePqForm extends BasePqForm {
    deviceId: number

    constructor(deviceId: number) {
        super()
        this.deviceId = deviceId;
    }
}

export class DshareForm {
    deviceId!: number
    toUserId!: number

    constructor() {
        this.init()
    }

    init(): void {
        this.deviceId = -1
        this.toUserId = -1
    }
}

export class DunshareForm {
    deviceId!: number
    toUserId!: number
}

export class DbindForm {
    id!: number
    userId!: number
}

export class DbaqForm {
    activeCode!: string
    mac!: string
    userId!: number
}
